import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export interface RoleChangeDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RoleChangeDialog = ({
  open,
  onConfirm,
  onCancel,
}: RoleChangeDialogProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Confirm Role Change</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You are about to promote this user from User to Admin.
      </Typography>
      <Typography variant="body2" sx={{ color: "#555" }}>
        Admins can invite users, remove users, and create tools. Pricing,
        billing, and ownership remain Owner-only. You can demote this user back
        to User at any time.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button onClick={onCancel} sx={{ textTransform: "none" }}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          bgcolor: "#ff8c00",
          color: "#fff",
          textTransform: "none",
          "&:hover": { bgcolor: "#e67e00" },
        }}
      >
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);
